import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MultiSelectModule } from 'primeng/multiselect';
import { TabViewModule } from 'primeng/tabview';
import { ButtonModule } from 'primeng/button';
import { RowComponent, FieldComponent } from '@src/app/components';

import {
  DatasourceFormDataType,
  DatasourceFormComponent as DatasourceFormModule,
  SourceTypes,
} from '../../../datasource-form';
import { UIFormDataType } from '../ui-form';

import { FormType } from './types';
import { BACK_SOURCE_TYPES, FRONT_SOURCE_TYPES } from './constants';

@Component({
  selector: 'filter-datasource-form',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MultiSelectModule,
    TabViewModule,
    ButtonModule,
    RowComponent,
    FieldComponent,
    DatasourceFormModule,
  ],
  templateUrl: './datasource-form.component.html',
  styleUrl: './datasource-form.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DatasourceFormComponent {
  readonly types = SourceTypes;
  readonly frontSourceTypes = FRONT_SOURCE_TYPES;
  readonly backSourceTypes = BACK_SOURCE_TYPES;

  @Input() form!: FormGroup<FormType>;
  @Input() loading = false;
  @Input() otherFilters?: UIFormDataType[];
  @Input() datasourceCopyData?: DatasourceFormDataType;

  get frontControl() {
    return this.form.controls.front;
  }

  get backControl() {
    return this.form.controls.back;
  }

  onCopyDataToBack() {
    if (this.datasourceCopyData) {
      this.backControl.patchValue(this.datasourceCopyData);
    }
  }
}
